module.exports = __webpack_public_path__ + "img/robot_xunjian.9641edca.png";